export const timeTokenToDate = (token: string | number) => {
  return new Date((parseInt(token.toString(), 10) / 10000000) * 1000);
};
